import React, { useMemo, useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Spinner } from "reactstrap";
import { useDataFetch } from '../../Hooks/Use-data-fetch';
import { formatNumber } from "../../utils/formatNumber";

const UsersGrowthChart = ({ province, city }) => {
    const { getData } = useDataFetch();
    const [chartData, setChartData] = useState({
        categories: [],
        users: [],
        growth: []
    });
    const [loading, setLoading] = useState(true);

    const { data: usersData, isLoading } = getData(
        ['users-last-three-months', province, city],
        '/users/last-three-months',
        {},
        { province, city }
    );

    useEffect(() => {
        if (usersData?.data?.data) {
            const months = usersData.data.data;
            const growth = usersData.data.growth || [];

            const categories = months.map(item => item.month);
            const usersCount = months.map(item => item.count);
            const growthPercentage = growth.map(item => item.percentage);

            setChartData({
                categories,
                users: usersCount,
                growth: growthPercentage
            });
            setLoading(false);
        }
    }, [usersData]);

    const options = useMemo(() => ({
        chart: {
            toolbar: {
                show: false
            }
        },
        colors: ["#22C55E", "#3B82F6"],
        plotOptions: {
            bar: {
                borderRadius: 4,
                columnWidth: "40%"
            }
        },
        stroke: {
            width: [0, 3],
            curve: "smooth"
        },
        dataLabels: {
            enabled: false
        },
        grid: {
            borderColor: "#F1F3F5"
        },
        legend: {
            show: true,
            position: "top",
            horizontalAlign: "left"
        },
        xaxis: {
            categories: chartData.categories
        },
        tooltip: {
            y: [
                { formatter: formatNumber },
                { formatter: (v) => `${v}%` }
            ]
        },
        yaxis: [
            {
                title: {
                    text: "Usuarios"
                },
                labels: {
                    formatter: (v) => formatNumber(Math.round(v))
                }
            },
            {
                opposite: true,
                title: {
                    text: "Tasa de Crecimiento (%)"
                }
            }
        ]
    }), [chartData.categories]);

    const series = [
        {
            name: "Usuarios",
            type: "column",
            data: chartData.users
        },
        {
            name: "Tasa de Crecimiento (%)",
            type: "line",
            data: chartData.growth
        }
    ];

    if (loading || isLoading) {
        return (
            <Card className="border-0 shadow-sm w-100">
                <CardBody className="text-center py-5">
                    <Spinner color="primary" />
                </CardBody>
            </Card>
        );
    }

    return (
        <Card className="border-0 shadow-sm w-100">
            <CardBody>
                <h6 className="fw-bold">
                    Tasa de Crecimiento de Usuarios
                </h6>
                <small className="text-muted">
                    (Últimos 3 meses)
                </small>
                <ReactApexChart
                    options={options}
                    series={series}
                    type="line"
                    height={250}
                />
            </CardBody>
        </Card>
    );
};

export default UsersGrowthChart;